interface DogColorInfo {
  name: string;
  colorHex: string;
}

interface DogColorInfos {
  [Key: number]: DogColorInfo;
}

const infos: DogColorInfos = {
  1001: { name: 'Caramel', colorHex: '#FFC58D' },
  1002: { name: 'Chocolate', colorHex: '#835547' },
  1003: { name: 'Coffee', colorHex: '#5C4942' },
};

export default infos;
